import { CampagneStatut } from '@common/services';

export const CAMPAGNE_STATUT_TEXTS = {
  [CampagneStatut.ARCHIVEE]: 'archivée',
  [CampagneStatut.EN_COURS]: 'en cours',
  [CampagneStatut.A_VENIR]: 'à venir',
};